import $ from 'jquery'
import 'magnific-popup'

export default {
    init() {
        // 'use strict'

        /* Bind: Login link */
        $('.showlogin').on('click.nmShowForm', function(e) {
            e.preventDefault();
            loginCouponShowForm('#nm-checkout-login-form', 'nm-login-popup');
        });
        
        
        /* Bind: Coupon link */
        $('.showcoupon').on('click.nmShowForm', function(e) {
            e.preventDefault();
            loginCouponShowForm('#nm-coupon-login-form', 'nm-coupon-popup');
        });
        
        
        /* Bind: Payment methods input/radio-button */
        var paymentsAnim = false;
        $(document).on('change', '.wc_payment_methods li > .input-radio', function(e) {
            var $this = $(this).parent('li'),
                $active = $this.parent('.wc_payment_methods').children('.active');
            
            $active.removeClass('active');
            $this.addClass('active');
            
            if (!paymentsAnim) {
                $active.children('.payment_box').hide();
                $this.children('.payment_box').show();
            }
        });


    
        /**
        *    Login/Coupon: Show popup form
        */
        function loginCouponShowForm($formContainer, containerClass) {
            $.magnificPopup.open({
                mainClass: containerClass + ' nm-mfp-fade-in',
                alignTop: true,
                closeMarkup: '<a class="mfp-close nm-font nm-font-close2"></a>',
                removalDelay: 180,
                items: {
                    src: $formContainer,
                    type: 'inline'
                }
            });
        }
    
    }
}